import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

type TProps = {
  title: string
  open: boolean
  handleCancel: () => void
  handleConfirm: () => void
  textContent?: string
  isWarning?: boolean
  children?: React.ReactNode
  isDisabled?: boolean
}

function ConfirmationDialog({
  title,
  open,
  handleCancel,
  handleConfirm,
  textContent = '',
  isWarning = false,
  children = null,
  isDisabled = false,
}: TProps) {
  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{textContent}</Typography>
        {children}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleCancel}
          variant="tertiary1"
          disabled={isDisabled}
        >
          {isWarning ? 'Cancel' : 'No'}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="tertiary1"
          disabled={isDisabled}
        >
          {isWarning ? 'Proceed' : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmationDialog
